import { ExternalTextSchema } from "contracts/boundaries/external-text";
import { pathDepth } from "../../boundaries/url-path.parser";
import type { JourneyRole } from "../../enums/scan";
import { JOURNEY_ROLE } from "../../enums/scan";
import {
  readsAsActionPage,
  readsAsUtilityPath,
} from "./boundaries/page-purpose.classifier";
import type { JourneyPage } from "./journeyTypes";
import { routeClusterKey } from "./scanModel";

export function classifyJourneyRole(input: {
  page: JourneyPage;
  inboundCount: number;
  outboundCount: number;
}): JourneyRole {
  const text = `${input.page.path} ${input.page.title ?? ""}`;
  if (input.page.path === "/" || input.inboundCount === 0)
    return JOURNEY_ROLE.ENTRY;
  if (readsAsActionPage(ExternalTextSchema.parse(text)))
    return JOURNEY_ROLE.ACTION;
  if (input.outboundCount === 0) return JOURNEY_ROLE.DESTINATION;
  if (pathDepth(input.page.path) <= 1 && input.outboundCount >= 2)
    return JOURNEY_ROLE.HUB;
  if (input.page.title || routeClusterKey(input.page.path) !== "home") {
    return JOURNEY_ROLE.CONTENT;
  }
  return JOURNEY_ROLE.UNCLASSIFIED;
}

export function journeyRoleLabel(role: JourneyRole): string {
  const labels: Record<JourneyRole, string> = {
    entry: "Entry page",
    hub: "Hub or orientation page",
    content: "Content or task page",
    action: "Next-step page",
    destination: "Onward destination",
    unclassified: "Unclassified page",
  };
  return labels[role];
}

export function journeyRoleOrder(role: JourneyRole): number {
  return {
    entry: 0,
    hub: 1,
    content: 2,
    unclassified: 2,
    action: 3,
    destination: 4,
  }[role];
}

export function isJourneyUtilityPage(page: JourneyPage): boolean {
  return readsAsUtilityPath(ExternalTextSchema.parse(page.path));
}
